import { useLang } from 'hooks/lang';

import { getSampleProjectUrl } from 'entities';

import { Table, Column, Row, IconButton, Button, Card } from 'components/Blocks';
import { EntityStatusTag } from 'components/Entities';
import { ChatIcon, ExpandIcon, RefreshIcon } from 'components/Icons';

import { RecruitmentModal, RecruitmentOwner } from 'pages/Recruitment/components';

import { useProjectProfile } from '../context';

import { listUpdate } from 'utils/array';

export function RecruitmentTab() {
  const { t } = useLang();

  const { project, openTask, queryParams, setQueryParams, recruitments } = useProjectProfile();

  return (
    <>
      <RecruitmentModal
        recruitmentId={queryParams.recruitmentId || null}
        close={() => setQueryParams({ recruitmentId: null })}
        onData={(recruitment) =>
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          recruitments.overwrite((old) => listUpdate(old, recruitment as any))
        }
      />

      <Column gap="6" className="mt-2">
        <Row justifyContent="space-between">
          <h6 className="phone:text-lg">{t('project-recruitments')}</h6>

          <IconButton onClick={recruitments.retry} size="small" tooltipContent="Refresh">
            <RefreshIcon size={20} />
          </IconButton>
        </Row>

        <Card>
          <Table
            items={recruitments.data}
            loading={recruitments.loading}
            spacing="medium"
            uniqueKey="id"
            columns={[
              {
                label: 'Sample Project',
                property: 'sampleId',
                render: ({ sampleId }) => (
                  <Button
                    size="fit"
                    variant="link"
                    className="text-sm font-normal text-inherit"
                    href={getSampleProjectUrl(sampleId, 'stats')}
                    linkTarget={sampleId}
                  >
                    {sampleId}
                  </Button>
                ),
              },

              {
                label: 'Task',
                className: 'text-center',
                render: ({ task }) => (
                  <Button
                    variant="ghost"
                    onClick={() => openTask(task)}
                    className="text-inherit"
                    tooltipContent={
                      <Row gap="2">
                        <ExpandIcon /> {t('open')}
                      </Row>
                    }
                  >
                    {project.tasks.find((t) => t.id === task)!.name}
                  </Button>
                ),
              },

              {
                label: t('country')!,
                property: 'country',
                className: 'text-center',
              },

              {
                label: t('owner')!,
                className: 'text-center',

                render: (recruitment) => (
                  <RecruitmentOwner
                    recruitment={recruitment}
                    updateRecruitment={(rec) =>
                      recruitments.overwrite((old) => listUpdate(old, rec))
                    }
                  />
                ),
              },

              {
                label: t('status'),
                className: 'text-center',
                render: ({ status }) => (
                  <EntityStatusTag target="recruitments" status={status} size="medium" />
                ),
              },

              {
                className: 'w-48',

                render: (recruitment) => {
                  return (
                    <Row justifyContent="flex-end">
                      <Row className="text-sm" gap="2">
                        {recruitment.commentCount} <ChatIcon />
                      </Row>

                      <IconButton onClick={() => setQueryParams({ recruitmentId: recruitment.id })}>
                        <ExpandIcon />
                      </IconButton>
                    </Row>
                  );
                },
              },
            ]}
          />
        </Card>
      </Column>
    </>
  );
}
